import { useState, useEffect } from "react";
import { Modal } from "reactstrap";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import SearchSiteSelect from "../../../components/comman/SiteSearchSelect";

export default function TransferMachineryModal({ modal, toggle, machineryId, machineryName, currentSiteName, currentSiteId, onSuccess }) {
    const [isLoading, setIsLoading] = useState(false);
    const [destSiteId, setDestSiteId] = useState("");
    const [siteList, setSiteList] = useState([]);
    const [error, setError] = useState("");
    const [remarks, setRemarks] = useState("");

    useEffect(() => {
        if (modal) {
            GetSiteList();
            setDestSiteId("");
            setRemarks("");
            setError("");
        }
    }, [modal]);

    const GetSiteList = (search) => {
        let API = apiUrl.get_site + `${search ? `?search=${search}` : ""}`;
        callApi(API, { method: "GET" }).then((response) => {
            if (response?.status === true) {
                const formattedData = response.data?.site
                    ?.filter((item) => item.id !== currentSiteId) // filter out current site
                    ?.map((item) => ({
                        value: item.id,
                        label: item.name,
                    })) || [];
                setSiteList(formattedData);
            }
        });
    };

    const handleClose = () => {
        toggle("transfer");
    };

    const handleSubmit = () => {
        if (!destSiteId) {
            setError("Destination site is required");
            return;
        }

        setIsLoading(true);
        const payload = {
            siteId: destSiteId,
            transferRemarks: remarks || null,
        };

        callApi(apiUrl.update_machinery + `?machineryId=${machineryId}`, {
            method: "POST",
            data: payload,
        }).then((res) => {
            setIsLoading(false);
            if (res?.status === true) {
                toast.success(res?.message || "Machinery transferred successfully");
                handleClose();
                onSuccess?.();
            } else {
                toast.error(res?.message || "Failed to transfer machinery");
            }
        });
    };

    return (
        <Modal isOpen={modal} toggle={handleClose} centered size="md">
            <div style={{ borderRadius: 12, overflow: "hidden", background: "#fff" }}>
                {/* Header */}
                <div style={{ padding: "24px 28px 16px", borderBottom: "1px solid #f1f5f9" }}>
                    <div className="d-flex align-items-start justify-content-between">
                        <div>
                            <h5 style={{ margin: 0, fontWeight: 800, fontSize: "1.2rem", color: "#0f172a" }}>
                                Transfer Machinery
                            </h5>
                            <p style={{ margin: "4px 0 0", fontSize: "0.88rem", color: "#64748b" }}>
                                {[machineryName, currentSiteName && `currently at ${currentSiteName}`].filter(Boolean).join(" · ")}
                            </p>
                        </div>
                        <button
                            onClick={handleClose}
                            style={{
                                background: "none",
                                border: "none",
                                fontSize: "1.3rem",
                                color: "#94a3b8",
                                cursor: "pointer",
                                lineHeight: 1,
                                padding: 0,
                            }}
                        >
                            ×
                        </button>
                    </div>
                </div>

                {/* Body */}
                <div style={{ padding: "24px 28px" }}>
                    {/* Site Search Dropdown */}
                    <div className="mb-3">
                        <SearchSiteSelect
                            label="Destination Site"
                            required
                            value={destSiteId}
                            options={siteList}
                            onSelect={(opt) => {
                                setDestSiteId(opt?.value || "");
                                setError(opt?.value ? "" : "Destination site is required");
                            }}
                            onSearch={(q) => GetSiteList(q)}
                            placeholder="Search & select site..."
                            errors={error}
                        />
                    </div>

                    {/* Remarks Input */}
                    <div>
                        <label
                            style={{
                                display: "block",
                                fontSize: "0.82rem",
                                fontWeight: 800,
                                letterSpacing: "0.08em",
                                textTransform: "uppercase",
                                color: "#64748b",
                                marginBottom: 8,
                            }}
                        >
                            Transfer Remarks
                        </label>
                        <input
                            type="text"
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            placeholder="Reason for transfer (optional)"
                            style={{
                                width: "100%",
                                border: "1px solid #cbd5e1",
                                borderRadius: 8,
                                padding: "10px 14px",
                                fontSize: "0.95rem",
                                color: "#1e293b",
                                outline: "none",
                                background: "#fff",
                            }}
                        />
                    </div>
                </div>

                {/* Footer */}
                <div
                    style={{
                        padding: "16px 28px",
                        borderTop: "1px solid #f1f5f9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        gap: 10,
                    }}
                >
                    <button
                        onClick={handleClose}
                        style={{
                            background: "#fff",
                            border: "1px solid #cbd5e1",
                            borderRadius: 8,
                            padding: "9px 22px",
                            fontSize: "0.95rem",
                            fontWeight: 600,
                            color: "#334155",
                            cursor: "pointer",
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={isLoading}
                        style={{
                            background: isLoading ? "#94a3b8" : "#4f46e5",
                            border: "none",
                            borderRadius: 8,
                            padding: "9px 22px",
                            fontSize: "0.95rem",
                            fontWeight: 600,
                            color: "#fff",
                            cursor: isLoading ? "not-allowed" : "pointer",
                        }}
                    >
                        {isLoading ? "Saving…" : "Transfer"}
                    </button>
                </div>
            </div>
        </Modal>
    );
}
